import { RegisterOptions } from "react-hook-form";

export const MAX_QUESTION_LENGTH = 140;
export const MIN_QUESTION_LENGTH = 5;
// Allow longer option labels to support languages like German
export const MAX_CHOICE_LENGTH = 95;
export const MIN_CHOICE_LENGTH = 1;

const asMessage = (value: unknown): string =>
    typeof value === "string" ? value : String(value);

export const getOptionsRules = (
    t: (key: string, options?: any) => unknown
): RegisterOptions => ({
    required: {
        value: true,
        message: asMessage(t("dialogs.poll_creation.option_required")),
    },
    maxLength: {
        value: MAX_CHOICE_LENGTH,
        message: asMessage(
            t("dialogs.poll_creation.option_maxLength", {
                length: MAX_CHOICE_LENGTH,
            })
        ),
    },
    minLength: {
        value: MIN_CHOICE_LENGTH,
        message: asMessage(t("dialogs.poll_creation.option_minLength")),
    },
    pattern: {
        value: /.*[^ ].*/,
        message: asMessage(t("dialogs.poll_creation.option_pattern")),
    },
});

export const getQuestionRules = (
    t: (key: string, options?: any) => unknown
): RegisterOptions => ({
    required: {
        value: true,
        message: asMessage(t("dialogs.poll_creation.question")),
    },
    maxLength: {
        value: MAX_QUESTION_LENGTH,
        message: asMessage(
            t("dialogs.poll_creation.question_maxLength", {
                length: MAX_QUESTION_LENGTH,
            })
        ),
    },
    minLength: {
        value: MIN_QUESTION_LENGTH,
        message: asMessage(
            t("dialogs.poll_creation.question_minLength", {
                length: MIN_QUESTION_LENGTH,
            })
        ),
    },
    pattern: {
        value: /.*[^ ].*/,
        message: asMessage(t("dialogs.poll_creation.question")),
    },
});

export const imagesOptionsRules = (isRequiredImgs: boolean) => {
    return {
        required: {
            value: isRequiredImgs,
            message: `You should add images for all options`,
        },
    };
};
